

export enum RegisteredCoursesProgress {
    LOGIN = 0,
    SELECT_SESSIONSEMESTER = 1,
    CONFIRMATION = 2,
}